import React from 'react';
import { MenuItem } from '@/types/base';
import MenusColl from './MenusColl';

interface MenusProps {
  selectMenuId:any
  menuList:MenuItem[],
  onMenuClick:(...args:any[])=>void
}

const prefix = 'Menus';
const Menus: React.FC<MenusProps> = (props) => {
  const {menuList,selectMenuId,onMenuClick}=props
  return (
    <>
       {
        menuList.map((item:MenuItem,index:number)=>{
          return <div key={item.key}>
            <MenusColl
              onMenuClick={onMenuClick}
              dirNameClass={""} 
              tier={-1} 
              data={item} 
              selectMenuId={selectMenuId}
            />
          </div>
        })
       }
    </>
  );
};

export default Menus;
